import bankDoBrasil from '../../banksPNG/bankDoBrasil.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoDoBrasilIcon = ({
	width = '17',
	height = '17',
	alt = 'Banco de Brasil',
}: IconProps) => <img src={bankDoBrasil} width={width} height={height} alt={alt} />;
